import { ThemeComponent } from "@/theme/ThemeComponent";
import { Component, Prop, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { formatPrice } from "@/utils/products";
import { CartItemRow } from "./CartItemRow";
import { cart } from "@/theme/Cart";
import { QuantitySpinner } from "../QuantitySpinner/QuantitySpinner";
import { html, render } from "lit-html";
import { ids } from "webpack";

interface Subscriptions extends HTMLElement {
    enabled: boolean;
    domain: string;
    customerParam: string;
}

// TODO - Checkout subscription cost breakdown
// interface Week {
//     id: string;
//     value: number;
// }

@Component
export class CartMain extends ThemeComponent {
    @Ref() checkoutButton!: HTMLAnchorElement;
    @Ref() emptyCart!: HTMLElement;
    @Ref() promoBanner!: HTMLElement;
    @Ref() items!: HTMLElement;
    @Ref() count!: HTMLElement;
    @Ref() summary!: HTMLElement;
    @Ref() summaryToggle!: HTMLButtonElement;
    @Ref() summaryDetails!: HTMLElement;
    @Ref() summaryContinue!: HTMLButtonElement;
    @Ref() summaryDelivery!: HTMLButtonElement;
    @Ref() subscriptionDetails!: HTMLElement;
    @Prop subscriptions!: Subscriptions;

    protected strings = this.dataset.strings? this.dataset.strings: '';
    private hasSubscription: boolean[] = [];
    private itemCount: number = 0;
    // TODO: Cart page subscription totals breakdown list
    // private subscriptionCost: number = 0;
    // private subscriptionWeek: string[] = [];
    // private subscriptionWeek = new Map<number, number>();
    // private subscriptionWeek = {} as Week;
    // private subscriptionWeek = object{} = {};
    // private subscriptionCheck: number[] = [];

    /**
     * Initialise.
     */
    init() {
        this.$subscribe(cart.onChange, () => this.cartUpdated());

        this.$listen(this.summaryToggle, 'click', () => {
            this.summaryToggle.classList.toggle('is-active');
            this.summaryDetails.classList.toggle('is-active');
            this.summaryContinue.classList.toggle('is-active');
            this.summaryDelivery.classList.toggle('is-active');
        });

        this.cartUpdated();
        this.checkFreeGift();
        this.showSummary();
    }

    getCookie(name: string) {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) {return match[2];}
    }

    rechargeCheck() {
        let checkoutUrl = '/checkout';

        if (this.hasSubscription.includes(true)) {
            checkoutUrl = `https://checkout.rechargeapps.com/r/checkout`;
            checkoutUrl += `?myshopify_domain=${this.subscriptions.domain}`;
            checkoutUrl += `&cart_token=${this.getCookie('cart')}`;

            if (this.subscriptions.customerParam) {
                checkoutUrl += `&${this.subscriptions.customerParam}`;
            }
        }

        this.checkoutButton.href = checkoutUrl;
    }

    /**
     * Update item count.
     * @param count - count
     */
    updateCount(count:number) {
        this.count.innerHTML = String(count);
        this.checkoutButton.innerHTML = `
            ${this.checkoutButton.dataset.string}
            - ${formatPrice(cart.totalPrice, String(JSON.parse(this.strings).moneyFormat))}
        `;
        document.dispatchEvent(new Event('cartItemChange'));
    }

    /**
     * Update Cart
     * @param container - items container.
     * @param emptyCart - cart empty message.
     * @returns
     */
    cartUpdated() {
        const itemsLength = cart.items.length;
        this.items.innerHTML = '';

        let length = 0;

        if (itemsLength <= 0) {
            this.emptyCart.style.display = 'block';
            this.checkoutButton.style.display ='none';
            this.updateCount(0);
            this.showSummary();
            return;
        }

        this.emptyCart.style.display = 'none';
        this.checkoutButton.style.display ='block';
        this.itemCount = 0;

        for (const item of cart.items) {
            this.hasSubscription[this.itemCount] = false;

            if (item.properties &&
                (item.properties.shipping_interval_frequency && item.properties.shipping_interval_frequency > 0)
            ) {
                this.hasSubscription[this.itemCount] = true;

                // TODO: Cart page subscription totals breakdown list
                //     if (!this.subscriptionCheck.includes(item.id)) {
                //         if (!item.properties.shipping_interval_frequency) { return; }
                //         const shippingInterval: number = parseInt(
                // `${item.properties.shipping_interval_frequency}`,10
                // );

                //         // need to add up any new totals within this.subscriptionweek and new lineprice
                //         let ship = this.subscriptionWeek.get(shippingInterval);
                //         // ship += item.linePrice;
                //         // this.subscriptionCost += item.linePrice;
                //         // this.subscriptionCost
                //         // this.subscriptionweek
                //         // need to update the existing
                //         // if (!this.subscriptionWeek.includes(`${item.properties.shipping_interval_frequency}`)) {
                //         // this.subscriptionWeek.(`${item.properties.shipping_interval_frequency}`);
                //         // }
                //         // `${item.properties.shipping_interval_frequency}`,
                //         this.subscriptionWeek.set(
                //             shippingInterval,
                //             item.linePrice
                //         );
                //         this.$log.info('subs', ship);
                //         this.$log.info('subs', this.subscriptionWeek);
                //         // this.subscriptionWeek.push('one week');
                //         // this.subscriptionWeek[array].push(item.linePrice)
                //         this.subscriptionCheck.push(item.id);
                //         // this.subscriptionWeek.push([])
                //     }
            }

            const row = new CartItemRow(
                item,
                new QuantitySpinner(1 , 99, item.quantity),
                this.strings,
                this.hasSubscription[this.itemCount]
            );

            this.itemCount += item.quantity; length++;
            this.items.append(row);

            if (length < itemsLength) { continue; }
            this.updateCount(this.itemCount);
            this.showSummary();
        }

        this.rechargeCheck();
    }

    showSummary() {
        // TODO: Cart page subscription totals breakdown list
        // let totals = '';

        // for (const [key, value] of new Map([...this.subscriptionWeek].sort())) {
        //     totals += `<p class="${this.summaryDetails.dataset.class}__summary-details__total">
        //         <span>Total to pay every ${key} week${key !== 1 ? 's' : ''}</span>
        //         <span>${formatPrice(value, String(JSON.parse(this.strings).moneyFormat))}</span>
        //     </p>`;
        // }

        render(html`
            <p class="${this.summaryDetails.dataset.class}__summary-details__subtotal">
                <span>Subtotal</span>
                <span>${formatPrice(cart.totalPrice, String(JSON.parse(this.strings).moneyFormat))}</span>
            </p>
            <p class="${this.summaryDetails.dataset.class}__summary-details__total">
                <span>Total to pay today</span>
                <span>${formatPrice(cart.totalPrice, String(JSON.parse(this.strings).moneyFormat))}</span>
            </p>
        `, this.summaryDetails);

        // this.subscriptionDetails.innerHTML = totals;
    }

    /**
     * Cheeck if eligible for free gift.
     * - free gift query is defined within Cart.ts
     */
    checkFreeGift() {
        this.promoBanner.style.display = cart.qualifiesForFreeGift ? '' : 'none';
    }
}
